const API_KEY = "a560b244567b8df79618c3fa33b6a022";
const BASE_URL = "https://api.openweathermap.org/data/2.5";

export const fetchWeather = async (city) => {
  try {
    const response = await fetch(
      `${BASE_URL}/weather?q=${city}&units=metric&appid=${API_KEY}`
    );
    if (!response.ok) throw new Error("City not found");
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchForecast = async (lat, lon) => {
  try {
    const response = await fetch(
      `${BASE_URL}/forecast?lat=${lat}&lon=${lon}&units=metric&appid=${API_KEY}`
    );
    if (!response.ok) throw new Error("Forecast failed");
    const data = await response.json();
    return data.list;
  } catch (error) {
    throw error;
  }
};

export const getWeatherByLocation = async (lat, lon) => {
  try {
    const response = await fetch(
      `${BASE_URL}/weather?lat=${lat}&lon=${lon}&units=metric&appid=${API_KEY}`
    );
    if (!response.ok) throw new Error("Location weather failed");
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
